/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const AccountManagementPage = lazyLoad(
  () => import('./index'),
  module => module.AccountManagementPage
);
